import { ExploraRequestAction } from 'app/store/actions';
import { useExploraDispatch, useExploraState } from 'app/store/explora-context';
import React, { lazy, Suspense, useEffect } from 'react';
import LoadingScreen from 'shared/components/LoadingScreen/LoadingScreen';
import BriefInfo from './pages/BriefInfo/BriefInfo';
import Landing from './pages/Landing/Landing';
import WhatWeDo from './pages/WhatWedo/WhatWeDo';

const Discover = lazy(() => import('./pages/Discover/Discover'));
const LatestLaunches = lazy(() => import('./pages/LatestLaunches/LatestLaunches'));
const ContactUs = lazy(() => import('./pages/ContactUs/ContactUs'));

const Home = () => {
  const { homeContent } = useExploraState();
  const { latestLaunches } = useExploraState();

  const dispatch = useExploraDispatch();

  useEffect(() => {
    if (homeContent.landing.title.length === 0) {
      const getHomeContent = async () => {
        try {
          await ExploraRequestAction.getHomeContent(dispatch);
        } catch {}
      };

      getHomeContent();
    }
  }, [dispatch, homeContent.landing.title]);

  if (homeContent.landing.title.length === 0) {
    return <LoadingScreen />;
  }

  return (
    <>
      <Landing />
      <BriefInfo />
      <WhatWeDo />
      <Suspense fallback={<LoadingScreen />}>
        <Discover />
        <LatestLaunches latestLaunches={latestLaunches} />
        <ContactUs />
      </Suspense>
    </>
  );
};

export default Home;
